(function () {
  if (window.relxMobileAutoplayReady) return;
  window.relxMobileAutoplayReady = true;
  var mobile = window.matchMedia('(max-width: 749px)');
  var states = new Map();
  var observer;
  var mutations;
  var frame;
  var active = false;

  function eligible(video) {
    return !video.matches('.rx-video-flavors__video, .rcf__video, .fm08m-video, [data-rx-auto-video]');
  }
  function visible(video) {
    var rect = video.getBoundingClientRect();
    var slide = video.closest('[data-product-single-media-wrapper]');
    if (slide && slide.closest('.flickityt4s-enabled') && !slide.classList.contains('is-selected')) return false;
    return video.isConnected && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }
  function play(video, state) {
    if (!active || document.hidden || !state.inView || !visible(video)) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('webkit-playsinline', '');
    video.autoplay = true;
    video.loop = true;
    var loaded = false;
    if (!video.getAttribute('src') && video.dataset.src) {
      video.src = video.dataset.src;
      loaded = true;
    }
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      if (!source.getAttribute('src')) {
        source.src = source.dataset.src;
        loaded = true;
      }
    });
    if (loaded) video.load();
    if (!video.paused) return;
    state.blocked = false;
    var attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(function (error) { state.blocked = error.name === 'NotAllowedError'; });
  }
  function sync() {
    frame = null;
    if (!active) return;
    var main = document.getElementById('MainContent') || document.body;
    main.querySelectorAll('video').forEach(function (video) {
      if (!eligible(video) || states.has(video)) return;
      var attributes = {};
      ['autoplay', 'muted', 'loop', 'playsinline', 'webkit-playsinline'].forEach(function (name) {
        attributes[name] = video.getAttribute(name);
      });
      var state = { attributes: attributes, muted: video.muted, inView: !observer && visible(video) };
      state.retry = function () { play(video, state); };
      states.set(video, state);
      video.addEventListener('canplay', state.retry);
      if (observer) observer.observe(video);
    });
    states.forEach(function (state, video) {
      if (!video.isConnected) {
        if (observer) observer.unobserve(video);
        video.removeEventListener('canplay', state.retry);
        states.delete(video);
        return;
      }
      if (!observer) state.inView = visible(video);
      if (document.hidden || !state.inView || !visible(video)) video.pause();
      else play(video, state);
    });
  }
  function queue() {
    if (active && !frame) frame = window.requestAnimationFrame(sync);
  }
  function retry() {
    states.forEach(function (state, video) { if (state.blocked) play(video, state); });
  }
  function stop() {
    active = false;
    if (observer) observer.disconnect();
    if (mutations) mutations.disconnect();
    if (frame) window.cancelAnimationFrame(frame);
    frame = null;
    states.forEach(function (state, video) {
      video.removeEventListener('canplay', state.retry);
      video.pause();
      Object.keys(state.attributes).forEach(function (name) {
        var value = state.attributes[name];
        if (value === null) video.removeAttribute(name);
        else video.setAttribute(name, value);
      });
      video.muted = state.muted;
      if (video.autoplay && visible(video) && !document.hidden) {
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      }
    });
    states.clear();
    observer = null;
    mutations = null;
  }
  function applyMode() {
    if (!mobile.matches) {
      if (active) stop();
      return;
    }
    if (active) return;
    active = true;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var state = states.get(entry.target);
          if (!state) return;
          state.inView = entry.isIntersecting && entry.intersectionRatio > 0;
          if (state.inView) play(entry.target, state);
          else entry.target.pause();
        });
      }, { threshold: [0, .01] });
    }
    var main = document.getElementById('MainContent') || document.body;
    mutations = new MutationObserver(queue);
    mutations.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden', 'src', 'data-src'] });
    sync();
  }
  if (mobile.addEventListener) mobile.addEventListener('change', applyMode);
  else mobile.addListener(applyMode);
  document.addEventListener('visibilitychange', queue);
  document.addEventListener('shopify:section:load', queue);
  document.addEventListener('shopify:section:unload', queue);
  document.addEventListener('pointerup', retry, { passive: true });
  document.addEventListener('touchend', retry, { passive: true });
  window.addEventListener('pageshow', queue);
  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('scroll', function () { if (!observer) queue(); }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyMode);
  else applyMode();
})();
